import type { FC } from 'react';
import { getGamesCurrenciesKey } from '@/helpers/gamesCurrencies';
import { useGetCommonStore } from '@/store';
import { GamesGridDynamic, type GamesGridProps } from './GamesGridDynamic';

export const GamesGrid: FC<GamesGridProps> = (props) => {
  const useCommonStore = useGetCommonStore();
  const currenciesKey = useCommonStore(getGamesCurrenciesKey);
  const listKey = `${props.category || props.provider}|${currenciesKey}`;

  return <GamesGridDynamic key={listKey} {...props} />;
};
